import { apiSlice } from "../app/apiSlice"
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from "./userRedux";
import productReducer from "./productRedux";
import eventReducer from "./eventRedux";
import eventDetailReducer from "./events/eventDetailSlice";
import paymentReducer from "./paymentRedux";
import authReducer from './auth/authSlice'
import cartReducer from './cart/cartSlice'
import membershipReducer from './membership/membershipSlice'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "rootgv",
  version: 3,
  storage,
  // blacklist: [apiSlice.reducerPath]
};

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  user: userReducer,
  product: productReducer,
  event: eventReducer,
  eventDetail: eventDetailReducer,
  payment: paymentReducer,
  cart: cartReducer,
  membership: membershipReducer

});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([apiSlice.middleware]),
  devTools: true
});



export let persistor = persistStore(store);

